import Menu from './Menu'
import HamburgerMenu from './HamburgerMenu'

export { HamburgerMenu }

export default Menu
